export default __webpack_public_path__ + "static/media/title-deco-bg.b11d6bda.webp";